import { colors } from "@areahub/theme";

/**
 *  Colors determined from [here](https://www.arcgis.com/home/webmap/viewer.html?url=https://services.arcgis.com/XG15cJAlne2vxtgt/ArcGIS/rest/services/National_Risk_Index_Annualized_Frequency_Coastal_Flooding/FeatureServer/1&source=sd)
 *  */
const COASTAL_FLOOD_STOPS = [
  -9999,
  colors.blueGray[200],
  0,
  colors.green[300],
  0.22,
  colors.amber[300],
  2.1,
  colors.orange[500],
  3.3,
  colors.red[500],
  4.02,
  colors.red[600],
];

/**
 *  Legend determined from [here](https://www.arcgis.com/home/webmap/viewer.html?url=https://services.arcgis.com/XG15cJAlne2vxtgt/ArcGIS/rest/services/National_Risk_Index_Annualized_Frequency_Coastal_Flooding/FeatureServer/1&source=sd)
 */
const getLegendRows = () => {
  return [
    ["> 4.02 – 4.5", 11],
    ["> 3.3 – 4.02", 9],
    ["> 2.1 – 3.3", 7],
    ["> 0.22 – 2.1", 5],
    ["0 – 0.22", 3],
    ["Not Applicable", 1],
  ].map((row) => ({
    icon: "draw-polygon",
    label: row[0] === "Not Applicable" ? row[0] : row[0] + " events/yr",
    color: COASTAL_FLOOD_STOPS[row[1] as number],
  }));
};

export const coastalFloods = {
  stops: COASTAL_FLOOD_STOPS,
  props: getLegendRows(),
};
